function DashboardReport(aUserId, aDescription) {
    "use strict";

    this.__type = 'DashboardReport:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Description = '';
    if (!isNullOrUndefined(aDescription)) {
        this.Description = aDescription;
    }
    this.IsActive = true;
    this.UserId = -1;
    if (!isNullOrUndefined(aUserId)) {
        this.UserId = aUserId;
    }
}
if (typeof exports !== 'undefined') {
    module.exports = DashboardReport;
}